import BookTrip from "../components/Widgets/BookTripWidget/BookTrip";
import Agent from "../components/Widgets/SatisfactoryWidget/Agent";
import PackingTips from "../components/Widgets/PackingTipsWidget/PackingTips";
import Register from "../components/Widgets/Register/Register";
import firebase from 'firebase/compat/app'
import 'firebase/compat/auth';
import 'firebase/compat/firestore';
import { createChatBotMessage } from "react-chatbot-kit";
import { useContext } from "react";
import AppContext from "../AppContext";
import { collection, addDoc,doc, setDoc } from 'firebase/firestore';
import { getFirestore } from 'firebase/firestore';

const firebaseConfig = {
  apiKey: "AIzaSyBKWdYhj6i6NcBAiXmhAktyI_bAMwAJuOo",
  authDomain: "tripz-travel-bot.firebaseapp.com",
  projectId: "tripz-travel-bot",
  storageBucket: "tripz-travel-bot.appspot.com",
  messagingSenderId: "720844828187",
  appId: "1:720844828187:web:00adcaa6e56ca989d0d2be",
  measurementId: "G-5BCYRZXXNW"
};

firebase.initializeApp(firebaseConfig)


class ActionProvider {
 

    constructor(createChatBotMessage, setStateFunc) {
        this.createChatBotMessage = createChatBotMessage;
        this.setState = setStateFunc;
  }
  
  
  // storeMessageInFirestore = async (userMessage, botMessage, formData) => {
    
  //   console.log(formData)
  //   try {
  //     const db = getFirestore();
  //     const messagesCollection = collection(db, 'messages');
  //     const documentId = formData.email;
    
  //     await setDoc(doc(messagesCollection, documentId), {
        
  //       userMessage: userMessage.text,
  //       botMessage: botMessage.text,
  //       timestamp: new Date(),
  //       isUser: userMessage.isUser,
  //     });
  
  //     console.log('Message stored in Firestore:', userMessage.text, botMessage.text);
  //   } catch (error) {
  //     console.error('Error storing message in Firestore:', error);
  //   }
  // };
  handleSubmit = (formData, selectedOption) => {
   
   
    switch (selectedOption) {
      case 'Flight Status':
        this.handleFlightStatus();
        break;
      case 'Book a Trip':
        this.handleBookATrip();
        break;
      case 'Find Hotels':
        this.handleFindHotels();
        break;
      case 'Packing Tips':
        this.handlePackingTips();
        break;
      case 'Register':
        this.handleRegister();
        break;
      case 'Find Vacation Spots':
        this.handleVacationSpots();
        break;
      case 'Flight Deals':
        this.handleFlightDeals();
        break;
      case 'Vehicle Rentals':
        this.handleVehicleRentals();
        break;
      default:
        const botMessage = this.createChatBotMessage('Sorry, I did not understand your request.');
        this.updateChatbotState(botMessage);
       
       
    }
   
  };


  //For GRETTINGS

  greet = async () => {
  

    const botMessage = this.createChatBotMessage('Hello! How can I assist?',{
        widget:'options'
      });
  //  this.storeMessageInFirestore(botMessage);
      this.updateChatbotState(botMessage);
    
  };
//  For Flight Status

  handleFlightStatus = () => {
  

    const botMessage = this.createChatBotMessage('Kindly provide your flight number to process your request',{
        widget:'flightNumber'
      });
  //  this.storeMessageInFirestore(botMessage);
      this.updateChatbotState(botMessage);
    
  };

  handleFlightNumberSubmit = (flightNumber) => {
    const botMessage= this.createChatBotMessage(`The flight ${flightNumber} is currently scheduled to depart on time at 10:00 AM and arrive at 2:00 PM.`, {
        widget:'satisfactory'
      });
  //  this.storeMessageInFirestore(botMessage);
      this.updateChatbotState(botMessage);
    
  }

// For Book a Trip
handleBookATrip= () => {
   
   
  const botMessage = this.createChatBotMessage(
    <BookTrip/>,{
      widget:'satisfactory'
    }
  );
//  this.storeMessageInFirestore(botMessage);
  this.updateChatbotState(botMessage);
  
};

// For Hotels



handleFindHotels = () => {
  const botMessage = this.createChatBotMessage('To find the nearest hotels to you, kindly provide the area of interest.',{
    widget:'hotelArea'
  });
//  this.storeMessageInFirestore(botMessage);
  this.updateChatbotState(botMessage);
  
}

handleHotelAreaSubmit = (hotelArea) => {
  const botMessage = this.createChatBotMessage(`The hotels in ${hotelArea} area are: The Prince Hotel, Souvre Hotel, The Chandler Suites, Prescott Hotel`, {
    widget:'satisfactory'
  });
//  this.storeMessageInFirestore(botMessage);
  this.updateChatbotState(botMessage);
  
}

// For packing tips

handlePackingTips = () => {
  const botMessage = this.createChatBotMessage(<PackingTips/>, {
    widget:'satisfactory'
  });
//  this.storeMessageInFirestore(botMessage);
  this.updateChatbotState(botMessage);
  
}

// For vacation spots


handleVacationSpots = () => {
  const botMessage = this.createChatBotMessage('There are several lovely places to visit such as the Gyeongbok Palace in Korea, Pyramids of Egypt in Egypt, Great Tower in Dubai, The Taj Mahal in India, Plitvice Lakkes in Croatia, the Great Barrier Reef in Australia, Bali and many more. We have many vacation deals for you to explore as you register with us today! Go out there and have fun!', {
    widget:'satisfactory'
  });
//  this.storeMessageInFirestore(botMessage);
  this.updateChatbotState(botMessage);
  
}


// For Flight deals

handleFlightDeals = () => {
  const botMessage = this.createChatBotMessage('We have flight deals that allow you book flights at the cheapest rates. You can travel from Lagos to Abuja for as low as N50,000, and even outside Nigeria, to Kenya or Egypt for as low as N100,000. Register with us today and enjoy flight deals as you book your flights.', {
    widget: 'satisfactory'
  });
//  this.storeMessageInFirestore(botMessage);
  this.updateChatbotState(botMessage);
  
}

//  For Register

handleRegister = () => {const botMessage = this.createChatBotMessage(<Register/>, {
    widget:'satisfactory'
  });
//  this.storeMessageInFirestore(botMessage);
  this.updateChatbotState(botMessage);
  
}

// For Vehicle Rentals

handleVehicleRentals = () => {
  const botMessage = this.createChatBotMessage('You can rent different type of vehicles with us such as buses, trucks and cars for a period of time on a budget. Register with us today to enjoy these offers!', {
    widget:'satisfactory'
  });
//  this.storeMessageInFirestore(botMessage);
  this.updateChatbotState (botMessage);
  
}


// For SatisfactoryWidget Options

  handleDirectToAgent = () => {
    const botMessage= this.createChatBotMessage(<Agent/>);
  //  this.storeMessageInFirestore(botMessage);
    this.updateChatbotState(botMessage);
    
  }

 handleAnotherRequest = () => {
  const botMessage= this.createChatBotMessage('Please select an option', {
      widget:'secondOptions'
    });
//  this.storeMessageInFirestore(botMessage);
    this.updateChatbotState(botMessage);
  
 }

 handleDefaultResponse=() =>{
  const botMessage= this.createChatBotMessage('Sorry, I do not understand your request. Please select an option:', {
    widget:'options'
  });
// this.storeMessageInFirestore(botMessage);
  this.updateChatbotState(botMessage);
 }
  

  updateChatbotState = (message) => {
    this.setState((prevState) => ({
      ...prevState,
      messages: [...prevState.messages, message],
    }));
  };

}

export default ActionProvider;

